export default 'https://tme.understood.org/assets/particles.5fffef6f.glb'